<template>
  <div class="training-detail-sell-page">
    <template v-if="training.id > 0">
      <training-introduction show-bar
                             :id="training.id"
                             :type="training.type"
                             :title="training.title"
                             :sell="training.sell"
                             :about="training.about"
                             :join-status="training.joinStatus"
                             :show-consult="render.showConsult"
                             :benefit-bar="render.benefitBar"
                             :bottom-bar="render.bottomBar"
                             :primary-price="render.primaryPrice"
                             :my-team-id="groupBuy.myTeamId"
                             :member-wx-group-qr-code="render.memberWxGroupQrCode"
                             @disabled-join="handleDisabledJoin"
                             @joined="handleJoined"
      >
        <header class="training-header">
          <product-cover :src="training.cover"
                         :alt="training.title"
                         :target-id="training.id"
                         target-type="training"
                         :show-get-point="render.showSharePoint"
          />
          <group-buy-block-header :rule="groupBuy.activity.rule"
                                  :startTime="groupBuy.activity.currentTime"
                                  :endTime="groupBuy.activity.endTime"
                                  :show-countdown="groupBuy.activity.showCountdown"
                                  v-if="showGroupBuyActivityHeader"
          />
          <div class="training-header-info">
            <div class="training-title">{{ training.title }}</div>
            <div class="training-summary">{{ training.summary }}</div>
            <div class="benefit-info-block">
            <span class="group-team-size"
                  v-if="groupBuy.activity"
            >{{ groupBuy.activity.teamSize }}人成团</span>
              <price :price="render.primaryPrice"
              />
            </div>
            <div class="training-member-block"
                 v-if="joinedMember.count > 5"
            >
              <div class="training-member-avatar-list">
                <ym-avatar class="user-avatar"
                           :class="`avatar-${index}`"
                           v-for="(item, index) in joinedMember.avatarList"
                           :key="index"
                           :avatar="item"
                           size="extra-small"
                />
              </div>
              <span class="training-member-count">{{ joinedMemberCountString }}</span>
            </div>
          </div>
        </header>
        <!-- 拼团 -->
        <div class="group-buy-activity"
             v-if="showGroupBuyActivity"
        >
          <group-buy-block class="group-buy-block"
                           v-if="groupBuy.activity"
                           :id="groupBuy.activity.id"
                           :desc="groupBuy.activity.desc"
                           :rule="groupBuy.activity.rule"
                           :start-time="groupBuy.activity.currentTime"
                           :end-time="groupBuy.activity.endTime"
                           :list="groupBuy.activity.team.list"
                           :max-list-num="groupBuy.activity.team.max"
                           :show-countdown="groupBuy.activity.showCountdown"
          />
        </div>
      </training-introduction>
    </template>

    <Skeleton v-else />
  </div>
</template>

<script>
  import TrainingIntroduction from '@/pages/Training/components/TrainingIntroduction';
  import Skeleton from '@/skeleton/TrainingIntroduction';
  import { getTrainingIntroduction } from '@/services/training';
  import GroupBuyBlock from '@/pages/GroupBuy/components/ProductDetailBlock';
  import GroupBuyBlockHeader from '@/pages/GroupBuy/components/ProductDetailBlockHeader';
  import Price from '@/components/Price/ProductDetailPrimaryPrice';
  import Avatar from '@/components/Avatar';
  import ProductCover from '@/components/ProductDetailHeaderCover';

  export default {
    name: 'TrainingDetailSellPage',
    components: {
      TrainingIntroduction,
      Skeleton,
      GroupBuyBlock,
      GroupBuyBlockHeader,
      Price,
      'ym-avatar': Avatar,
      ProductCover,
    },
    data() {
      return {
        training: {
          id: 0,
          type: 'online',
          cover: '',
          title: '',
          summary: '',
          joinStatus: '',
          sell: {
            startTime: '',
            status: '',
          },
        },
        joinedMember: {
          avatarList: [],
          count: 0,
        },
        groupBuy: {
          activity: null,
          myTeamId: 0,
        },

        render: {
          gift: {
            show: false,
          },
          primaryPrice: {
            current: {
              value: 0,
              name: '',
            },
            origin: {
              value: 0,
              name: '',
            },
            benefit: null,
          },
          benefitBar: {
            show: false,
            desc: '',
            startTime: 0,
            endTime: 0,
          },
          bottomBar: {
            show: false,
            actionBar: {
              type: 'default',
              buttons: [],
            },
            renderPrice: {
              value: 0,
              delete: 0,
              name: '',
            },
          },
          showConsult: false,
          memberWxGroupQrCode: '',
        },

        showWxGroupQrCode: false,

      };
    },
    computed: {
      showGroupBuyActivity() {
        return this.groupBuy.activity && this.groupBuy.activity.team.list.length > 0;
      },
      showGroupBuyActivityHeader() {
        return this.groupBuy.activity && this.groupBuy.activity.team.list.length === 0;
      },
      joinedMemberCountString() {
        return this.joinedMember.count > 0 ? `等${this.joinedMember.count}人加入` : '刚刚加入';
      },
    },
    watch: {
      $route(val) {
        const { id } = val.params;
        this.fetchTrainingDetail(id);
      },
    },
    methods: {
      async fetchTrainingDetail(id) {
        const data = await getTrainingIntroduction(id);
        this.training = data.training;
        this.groupBuy = data.groupBuy;
        this.joinedMember = data.joinedMember;
        this.render = data.render;
      },
      handleJoined() {
        this.$emit('joined');
      },
      handleDisabledJoin() {
        const { id } = this.$route.params;
        this.fetchTrainingDetail(id);
      },
      handleShowQrCode() {
        this.showWxGroupQrCode = true;
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchTrainingDetail(id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.fetchTrainingDetail(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-detail-sell-page {
    height: 100%;
    background-color: @color-white;
  }

  .training-header-info {
    background-color: @color-white;
    padding: @size-base;
  }

  .training-title {
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    margin-bottom: @size-small;
  }

  .training-summary {
    color: @color-text-base;
    font-size: @font-size-small;
  }

  .benefit-info-block {
    margin-top: @size-base;
  }

  .group-team-size {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding: (@size-extra-small / 2) (@size-extra-small * 1.5);
    margin-bottom: @size-extra-small / 2;
    font-size: @font-size-extra-small;
    color: @group-buy-team-size-color;
    background: @group-buy-team-size-background;
    border-radius: @border-radius-medium;
  }

  .training-member-block {
    margin-top: @size-base;
    padding-top: @size-base;
    display: flex;
    align-items: center;
    border-top: @border-width-base @border-style-base @border-color-base;
  }

  .training-member-avatar-list {
    line-height: 1;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding-left: @size-small;
  }

  .user-avatar {
    margin-left: -@size-extra-small;
  }

  .training-member-count {
    color: @color-text-light;
    font-size: @font-size-extra-small;
    margin-left: @size-extra-small;
  }

  .group-buy-activity {
    padding-bottom: @size-small;
    background: @background-color-base;
  }
</style>
